module.exports = {"131022100":"固安镇","131022101":"宫村镇","131022102":"柳泉镇","131022103":"牛驼镇","131022104":"马庄镇","131022200":"东湾乡","131022201":"彭村乡","131022202":"渠沟乡","131022203":"礼让店乡","131022400":"固安温泉休闲商务产业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/131022.json
// module id = 321
// module chunks = 0